import { PaymentStatusComponent } from "./components";

export function PaymentInformationForm() {
  return <></>;
}

PaymentInformationForm.PaymentStatus = PaymentStatusComponent;
